// extracted by mini-css-extract-plugin
module.exports = {"avatar":"profile-photo-module--avatar--2SK_S"};